const FootLink = () => {
  return (
    <div className="footer">
      <div className="footer-content">
        <span style={{ fontSize: "15px" }}>👉</span> Made with ❤️ by{" "}
        <a
          href="https://www.linkedin.com/in/rushabh-wadkar/"
          rel="noreferrer"
          target="_blank"
        >
          Rushabh Wadkar
        </a>
      </div>
    </div>
  );
};

export default FootLink;
